export default "__VITE_ASSET__Bz8mDQ6X__"